    angular
    .module('GorillaBoy.FileBrowser')
    .constant('DraggableStyle', {
        DRAGGABLE_BACKGROUND_ACTIVE: '#ededec',
        DRAGGABLE_BACKGROUND_INACTIVE: '#FFFFFF',
        DRAGGABLE_COLOR: '#C8C7C7'
    })
    .config(['$routeProvider', function ($routeProvider) {
        var TEMPLATE_LAYOUT = './assets/partials/app/layout.html';

        // Angular's resolve hashmap values need to be either Promises or a function.
        // This makes it shorter to generate functions that return a given value.
        function makeReturnFunc(returnValue) {
            return function () { return returnValue; };
        }

        function resolveUserInfo () {
            return ['AuthService', '$location', '$q', function (authService, $location, $q) {
                return authService.getUserInfo().then(null, function(error) {
                    $log.error("Encountered error while fetching userInfo inside resolveUserInfo of filebrowser module.js");
                    $location.url('/genericError');
                    return $q.reject(error);
                });
            }];
        }
        
        function resolveView(viewName){
            if(viewName === 'SHARED' || viewName === 'FAVORITES' || viewName === 'FOLDER'){
                return function () { return viewName; };
            }
            return ['$q', 'AuthService', '$location', '$log', function ($q, authService, $location, $log) {

                var deferred = $q.defer(),
                    params = $location.search();
                authService.getUserInfo()
                .then(function (user) {
                    if (viewName === 'RECOVERY' && (!(user && user.Administrator) || !params.userId)){

                        $location.url('/mydocs').replace();
                        deferred.reject();

                    } else if (user && user.MinimalUser) {
                        $location.url('/shared').replace();
                        deferred.reject();

                    } else {
                        deferred.resolve(viewName);
                    }
                }, function(error) {
                    $log.error("Encountered error while fetching userInfo inside resolveView(" + viewName + ") of filebrowser module.js");
                    $location.url('/genericError');
                    return $q.reject(error);
                });

                return deferred.promise;
            }];
        }
        function getUserFavorites(useCache) {
            return ['FavoritesService', 'FeatureManagerService', '$q', 'Features', '$log', '$location', function(FavoritesService, FeatureManagerService, $q, Features, $log, $location) {
                return $q(function(resolve, reject) {
                    if (FeatureManagerService.isFeatureEnabled(Features.UI.FAVORITES)) {
                        if (useCache) {
                            FavoritesService.getCachedUserFavorites().then(resolve, reject);
                        } else {
                            FavoritesService.getUserFavorites().then(resolve, reject);
                        }
                    } else {
                        //Resolve with empty data.
                        resolve({Documents : [], Folders : []});
                    }
                })
                .then(null, function(error) {
                    $log.error("Encountered error inside getUserFavorites of filebrowser module.js");
                    $location.url('/genericError');
                    return $q.reject(error);
                });
            }];
        }
        function getUserRecoveryBinInfo(viewName) {
            if (viewName !== 'RECOVERY') {
                return function () { return null; };
            }
            return ['$location', '$q', 'UserService', 'AuthService', '$log', function($location, $q, UserService, AuthService, $log){

                var deferred = $q.defer();

                var params = $location.search();

                if (!params.userId) {
                    deferred.resolve();
                } else {

                    UserService.getUserById(params.userId)
                    .then(function (response) {
                        var userInfo = response.data.User;
                        deferred.resolve(userInfo);
                    }, function (error) {
                        $location.url('/mydocs').replace();
                        deferred.reject();
                    });
                }
                deferred.promise.then(null, function(error) {
                    $log.error("Encountered error inside getUserRecoveryBinInfo of filebrowser module.js");
                    $location.url('/genericError');
                    return $q.reject(error);
                });
                return deferred.promise;
            }];
        }

        /**
         * Even though all the method calls are triggered at once (resulting in multiple promises to be resolved),
         * the userInfo promise will be synchronously resolved since it maintains a local cache of User object
         */
        function resolveForView (viewName) {
            return {
                Anonymous: makeReturnFunc(false),
                View: resolveView(viewName),
                userInfo: resolveUserInfo(),
                Favorites : getUserFavorites(viewName !== 'FAVORITES'),
                UserRecoveryBinInfo: getUserRecoveryBinInfo(viewName),
                // HACK: while the featureMap isn't used directly, we do need the list of features
                //to be available (i.e. fetched) within the controller.
                // We could improve this by depending on FeatureMap rather than on the service directly
                featureMap: ['FeatureManagerService', '$log', '$location', '$q', function (featureManagerService, $log, $location, $q) {
                    return featureManagerService.getEnabledFeatureMap()
                        .then(null, function(error) {
                            $log.error("Encountered error while fetching userInfo inside resolveUserInfo of filebrowser module.js");
                            $location.url('/genericError');
                            return $q.reject(error);
                        });
                }]
            };
        }

        $routeProvider
        .when('/folder/:folderId', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'FileBrowserController',
            auth: true,
            resolve: resolveForView('FOLDER')
        })
        .when('/mydocs', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'FileBrowserController',
            auth: true,
            resolve: resolveForView('OWNED')
        })
        .when('/shared', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'FileBrowserController',
            auth: true,
            resolve: resolveForView('SHARED')
        })
        .when('/sharedByMe', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'FileBrowserController',
            auth: true,
            resolve: resolveForView('SHARED_BY_ME')
        })
        .when('/feedback', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'FileBrowserController',
            auth: true,
            resolve: resolveForView('AWAITING_FEEDBACK')
        })
        .when('/review', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'FileBrowserController',
            auth: true,
            resolve: resolveForView('OUT_FOR_REVIEW')
        })
        .when('/recycle', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'FileBrowserController',
            auth: true,
            resolve: resolveForView('RECYCLE')
        })
        .when('/recovery', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'FileBrowserController',
            auth: true,
            resolve: resolveForView('RECOVERY')
        })
        .when('/hdriveMigration', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'MigrationController',
            auth: true,
            resolve: resolveForView('OWNED')
        })
        .when('/favorites', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'FileBrowserController',
            auth: true,
            resolve: resolveForView('FAVORITES')
        })
        .when('/myNote', {
            templateUrl: TEMPLATE_LAYOUT,
            controller: 'FileBrowserController',
            auth: true,
            resolve: resolveForView('NOTE')
        });
    }]);

    